import{useEffect as n}from"react";function t(t,e){n((function(){if("undefined"!=typeof window)return t()}),[e])}export{t as default,t as useEffectBrowser};
//# sourceMappingURL=useEffectBrowser.js.map
